import { ErasmusServicePath } from "utils/constants";
import { buildFilterQueryString, buildQueryString } from "utils/helpers";

export const erasmusRequests = {
  addUniversityToCampaign: (id, universityId) => `${ErasmusServicePath}campaigns/${id}/universities/${universityId}`,
  // POST with the contract number and the attached documents - responds with the generated pdf
  postCampaignSelectionProtocol: id => `${ErasmusServicePath}campaigns/${id}/selection-protocol`,

  approveIncomingInternshipStudentByCoordinator: id =>
    `${ErasmusServicePath}incoming/internship-students/${id}/approve`,
  rejectIncomingInternshipStudentByCoordinator: id => `${ErasmusServicePath}incoming/internship-students/${id}/reject`,
  arriveIncomingInternshipStudent: id => `${ErasmusServicePath}incoming/internship-students/${id}/arrive`,
  finishIncomingInternshipStudent: id => `${ErasmusServicePath}incoming/internship-students/${id}/finish`,
  updateIncomingInternshipStudentInternships: id =>
    `${ErasmusServicePath}incoming/internship-students/${id}/internships`,
  updateIncomingInternshipStudentMotivationLetter: id =>
    `${ErasmusServicePath}incoming/internship-students/${id}/motivation-letter`,
  updateIncomingInternshipStudentLearningAgreement: id =>
    `${ErasmusServicePath}incoming/internship-students/${id}/learning-agreement`,

  // Generated documents (PDF) - see ErasmusInternshipDocuments for the paths
  getIncomingInternshipDocument: (id, documentPath) =>
    `${ErasmusServicePath}incoming/internship-students/${id}/${documentPath}`,
  // The certificate of arrival is the only generated document with its own query parameters -
  // hostUniversity, hostCountry and email are all required (a missing one is rejected with 400)
  getIncomingInternshipCertificateOfArrival: (id, params) =>
    `${ErasmusServicePath}incoming/internship-students/${id}/certificate-of-arrival${buildQueryString(params)}`,

  completeIncomingEmployee: id => `${ErasmusServicePath}incoming/employees/${id}/complete`,
  completeOutgoingEmployee: id => `${ErasmusServicePath}outgoing/employees/${id}/complete`,
  getIncomingEmployeeCertificateOfStay: id => `${ErasmusServicePath}incoming/employees/${id}/certificate-of-stay`,
  getIncomingEmployeeCertificateOfTeaching: id =>
    `${ErasmusServicePath}incoming/employees/${id}/certificate-of-teaching`,

  signIncomingStudentsRegular: id => `${ErasmusServicePath}incoming/students/regular/${id}/sign`,
  finishIncomingStudentsRegular: id => `${ErasmusServicePath}incoming/students/regular/${id}/finish`,
  arriveIncomingStudentsRegular: id => `${ErasmusServicePath}incoming/students/regular/${id}/arrive`,
  getIncomingStudentsRegularCurriculums: id => `${ErasmusServicePath}incoming/students/regular/${id}/curriculums`,
  getIncomingStudentsRegularDocument: (id, documentPath) =>
    `${ErasmusServicePath}incoming/students/regular/${id}/${documentPath}`,
  getIncomingStudentsRegularCertificateOfArrival: (id, params) =>
    `${ErasmusServicePath}incoming/students/regular/${id}/certificate-of-arrival${buildQueryString(params)}`,
  updateIncomingStudentsRegularDisciplines: id => `${ErasmusServicePath}incoming/students/regular/${id}/disciplines`,
  // Attached documents (arbitrary) - POST (multipart) & GET share the same URL
  incomingStudentsRegularDocuments: id => `${ErasmusServicePath}incoming/students/regular/${id}/documents`,
  deleteIncomingStudentsRegularDocument: (id, documentRowId) =>
    `${ErasmusServicePath}incoming/students/regular/${id}/documents/${documentRowId}`,

  deleteCoordinator: id => `${ErasmusServicePath}coordinators/${id}`,

  getCommitionRolesSelect: () => `${ErasmusServicePath}selects/commission-roles`,
  getCoordinatorStatusesSelect: () => `${ErasmusServicePath}selects/coordinator-statuses`,
  getCampaignSeasonsSelect: () => `${ErasmusServicePath}selects/campaign-seasons`,
  getStatusesSelect: () => `${ErasmusServicePath}selects/statuses`,
  getInternshipStatusesSelect: () => `${ErasmusServicePath}selects/internship-statuses`,
  getCycleOfEducationSelect: () => `${ErasmusServicePath}selects/cycle-of-education`,
  getNationalityTypesSelect: () => `${ErasmusServicePath}selects/nationality-types`,

  // Erasmus applications
  updateErasmusStatus: id => `${ErasmusServicePath}applications/${id}`,
  getApplicationStatusesSelect: () => `${ErasmusServicePath}selects/application-statuses`,
  getMobilityTypesSelect: () => `${ErasmusServicePath}selects/mobility-visit-type`,
  getApplicationsNextStatusSelect: (status, ids) =>
    `${ErasmusServicePath}applications/next-statuses${buildFilterQueryString({ status, Ids: ids })}`,
  returnApplicationForCorrection: id => `${ErasmusServicePath}applications/${id}/return-for-correction`,
  updateApplicationTransport: id => `${ErasmusServicePath}applications/${id}/transport`,
  updateApplicationFinalReport: id => `${ErasmusServicePath}applications/${id}/final-report`,
  updateAbsenceDates: id => `${ErasmusServicePath}applications/${id}/absence-dates`,
  getBusinessTripReport: id => `${ErasmusServicePath}applications/${id}/business-trip-report`,
  postBusinessTripOrder: id => `${ErasmusServicePath}applications/${id}/business-trip-order`,
  // POST with the parts of the template the server does not own - responds with the generated pdf
  postFundingContract: id => `${ErasmusServicePath}applications/${id}/funding-contract`,
  completeApplication: id => `${ErasmusServicePath}applications/${id}/complete`,
};
